import { render, staticRenderFns } from "./SessionEndResume.vue?vue&type=template&id=45496001&scoped=true&"
import script from "./SessionEndResume.vue?vue&type=script&lang=js&"
export * from "./SessionEndResume.vue?vue&type=script&lang=js&"
import style0 from "./SessionEndResume.vue?vue&type=style&index=0&id=45496001&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45496001",
  null
  
)

export default component.exports